// NOTE: reset styles must be first so later styles can override it
// eslint-disable-next-line simple-import-sort/imports
import resetStyles from "../styles/reset.module.scss"
import classNames from "classnames"
import React from "react"
import { useSizing } from "../helpers/use-sizing"
import { PrimitiveBaseProps, PrimitiveWithSizing } from "../helpers/types"

interface Props
  extends React.InputHTMLAttributes<HTMLInputElement>,
    PrimitiveBaseProps<HTMLInputElement>,
    PrimitiveWithSizing {
  // YOLOSWAG hack
  // There should be a more comprehensvie way to specify labels, etc
  label?: string
  labelLayout?: "horizontal" | "vertical"
}

export function Input(props: Props) {
  const {
    className,
    innerRef,
    label,
    labelLayout = "vertical",
    "data-node-id": dataNodeId,
    mainAxisSizing = "hug",
    crossAxisSizing = "hug",
    ...otherProps
  } = props

  const sizingClassName = useSizing(mainAxisSizing, crossAxisSizing)

  if (label && labelLayout === "horizontal") {
    return (
      <div
        className={classNames(
          "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5",
          className,
          sizingClassName,
        )}
        data-node-id={dataNodeId}
        ref={innerRef}
      >
        <label htmlFor={label} className="block text-base font-semibold text-gray-900 sm:mt-px sm:pt-2">
          {label}
        </label>
        <div className="mt-1 sm:mt-0 sm:col-span-2">
          <input
            type="text"
            name={label}
            className={classNames(
              resetStyles.reset,
              "bg-white p-2 max-w-lg block w-full focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs text-base border-gray-300 border border-solid rounded",
            )}
            {...otherProps}
          />
        </div>
      </div>
    )
  }

  if (label && labelLayout === "vertical") {
    return (
      <div className={classNames(className, sizingClassName)} data-node-id={dataNodeId} ref={innerRef}>
        <label htmlFor={label} className="block text-base font-semibold text-gray-900">
          {label}
        </label>
        <div className="mt-1">
          <input
            type="text"
            name={label}
            id={label}
            className={classNames(
              resetStyles.reset,
              "bg-white p-2 focus:ring-indigo-500 focus:border-indigo-500 block w-full text-base border-gray-300 border border-solid rounded",
            )}
            {...otherProps}
          />
        </div>
      </div>
    )
  }

  return (
    <input
      {...otherProps}
      className={classNames(resetStyles.reset, sizingClassName, className)}
      data-node-id={dataNodeId}
      ref={innerRef}
    />
  )
}
